module.exports = __webpack_public_path__ + "static/media/2.f854c8fb.svg";